'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Template = require('common/ui/template/project/member-role.hbs');

module.exports = Mn.View.extend({
    large: false,

    tagName: 'span',
    className: 'project-member-role',
    template: Template,
    serializeData: function() {
        return {
            role: i18n.t(`base:project-role.${this.model.getRole()}`),
            isSuspended: this.model.isSuspended()
        };
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/project/member-role.js